import type {
  MemberGroupColumns,
  MemberGroupMemberColumns,
  MemberGroupsFilters
} from '@library/types/memberGroups';
import type { TableColumn } from '@library/types/utils';

export const MEMBER_GROUPS_HEADER: TableColumn<MemberGroupColumns>[] = [
  {
    column: 'name',
    essential: true,
    label: 'Member Group',
    sortEnabled: true
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true
  },
  {
    column: 'description',
    essential: true,
    label: 'Description',
    sortEnabled: true
  },
  // {
  //   column: 'member_count',
  //   essential: true,
  //   label: 'Members',
  //   sortEnabled: false
  // },
  // {
  //   column: 'owner',
  //   essential: true,
  //   label: 'Owner',
  //   sortEnabled: false
  // },
  {
    column: 'updated_at',
    essential: true,
    label: 'Last modified',
    // width: 'w-1/5',
    sortEnabled: true
  }
];

export const DEFAULT_MEMBER_GROUPS_FILTERS: MemberGroupsFilters = {
  name: '',
  description: ''
};

export const MEMBER_GROUP_MEMBERS_HEADER: TableColumn<MemberGroupMemberColumns>[] =
  [
    {
      column: 'member',
      essential: true,
      label: 'Member',
      sortEnabled: false,
      width: 'basis-96'
    },
    {
      column: 'id',
      essential: true,
      label: 'ID',
      sortEnabled: false
    },
    // {
    //   column: 'tag',
    //   essential: true,
    //   label: 'Tag',
    //   sortEnabled: false
    // },
    {
      column: 'created_at',
      essential: true,
      label: 'Joined on',
      sortEnabled: false
    }
    // {
    //   column: 'lineups_created',
    //   essential: true,
    //   label: 'Lineups created',
    //   sortEnabled: false
    // },
    // {
    //   column: 'last5HitRate',
    //   // essential: true,
    //   label: 'Last 5 hit rate'
    // }
  ];
